import { useContext } from "react";
import {
	type HasSidebarContextType,
	type NoSidebarContextType,
	SidebarDrawerContext,
} from "./menu-state-provider";

export function useMenuState(): HasSidebarContextType | NoSidebarContextType {
	const context = useContext(SidebarDrawerContext);

	if (context === undefined) {
		return {
			hasSidebar: false,
			isDrawerOpen: false,
			toggleDrawer: () => {},
			setDrawerOpen: () => {},
			navigate: () => {},
			isDesktop: false,
		} satisfies NoSidebarContextType;
	}

	return context;
}
